import { lazy } from "react";
import { constants } from "../context/constants";

const Home = lazy(() => import("../pages/Home/Home"));
const Signin = lazy(() => import("../pages/Signin/Signin"));
const Signup = lazy(() => import("../pages/Signup/Signup"));
const Account = lazy(() => import("../pages/Account/Account"));
const Shop = lazy(() => import("../pages/Shop/Shop"));
const Combos = lazy(() => import("../pages/Combos/Combos"));
const Category = lazy(() => import("../pages/Category/Category"));
const Cart = lazy(() => import("../pages/Cart/Cart"));
const Purchase = lazy(() => import("../pages/Purchase/Purchase"));
const PurchaseSummary = lazy(() => import("../pages/PurchaseSummary/Summary"));
const Movements = lazy(() => import('../pages/Movements/Movements'));
const Recharge = lazy(() => import('../pages/Recharge/Recharge'));
const RechargeHistory = lazy(() => import('../pages/Recharge/RechargeHistory'));
const CredentialTemplate = lazy(() => import('../pages/CredentialTemplate/CredentialTemplate'));
const NotFound = lazy(() => import('../pages/NotFound/NotFound'));

const routes = [
    { path: '/', component: Home },
    { path: '/signin', component: Signin },
    { path: '/signup', component: Signup },
    { path: '/account', component: Account, private: true },
    { path: '/shop', component: Shop},
    { path: '/combos', component: Combos },
    { path: '/category/:category_id', component: Category },
    { path: '/cart', component: Cart },
    { path: '/purchase', component: Purchase, private: true },
    { path: '/purchaseSummary', component: PurchaseSummary, private: true },
    { path: '/movements', component: Movements, private: true },
    { path: '/recharge', component: Recharge, private: true },
    { path: '/recharge/historial', component: RechargeHistory, private: true },
    {
        path: '/distribuidor/plantilla',
        component: CredentialTemplate,
        private: true,
        allowedRoles: constants.CREDENTIAL_TEMPLATE_ROLES
    },
    { path: '*', component: NotFound },
];
  
export default routes;
